import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getRoleRouteRedirect } from "@/lib/roleAccess";

/** Enforces role-appropriate access to `/admin/*` vs org portal routes. */
export function RoleAccessOutlet() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const target = getRoleRouteRedirect(user, pathname);
  if (target) return <Navigate to={target} replace />;
  return <Outlet />;
}
